import React from 'react';
import classes from './PostCardStatusIcon.module.scss';
import { PostItemFragment } from '../../../models/graphql';
import { Tooltip } from '../../actions/Tooltip';
import { Icon } from '../../images/Icon/Icon';
import { IconsEnum } from '../../../constants/icons';

export type PostCardStatusIconViewProps = {
  post: PostItemFragment;
};

export const PostCardStatusIconView = ({ post }: PostCardStatusIconViewProps): JSX.Element => {
  return (
    <div id={`PostTimeIcon-${post.id}-${post.status}`} className={classes.TimingIconWrapper}>
      <Tooltip type={'regular'} target={`#PostTimeIcon-${post.id}-${post.status}`} pointer={true} position={'bottom'}>
        <>This post is manually scheduled</>
      </Tooltip>
      <div>
        <Icon name={IconsEnum.pin} size={'medium'} />
      </div>
    </div>
  );
};
